import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { type LaunchParams } from "@telegram-apps/sdk-react";
import { useAtom } from "jotai";

import { referrerAtom } from "@arc/shared/atoms/user";

import { StartParamsCodes } from "@/constants/launchParamsCodes";
import { BankRoute } from "@/constants/routes";

import { isValidAddress } from "../isValidAddress";

export const useStartParamsParser = (lp: LaunchParams) => {
  const navigate = useNavigate();

  const [referrer, setReferrer] = useAtom(referrerAtom);

  // NOTE: Enable debug mode to see all the methods sent and events received.
  useEffect(() => {
    if (!lp.initData?.startParam) {
      return;
    }

    let startParamsString = lp.initData.startParam;

    if (startParamsString.startsWith(StartParamsCodes.DEBUG)) {
      console.info(` v${__APP_VERSION__} at ${__COMMIT_HASH__}`);
      import("eruda").then((lib) => lib.default.init());
      startParamsString = startParamsString.slice(StartParamsCodes.DEBUG.length);
    }

    if (startParamsString.startsWith(StartParamsCodes.BUY)) {
      navigate(BankRoute.buy);
      return;
    }

    if (isValidAddress(startParamsString)) {
      if (referrer) {
        return;
      }

      setReferrer(startParamsString);
      return;
    }

    if (startParamsString.startsWith(StartParamsCodes.REFERRER_ADDRESS)) {
      if (referrer) {
        return;
      }

      const referrerAddress = startParamsString.slice(StartParamsCodes.REFERRER_ADDRESS.length + 1); // ref=

      if (!isValidAddress(referrerAddress)) {
        return;
      }

      setReferrer(referrerAddress);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
